// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__1lGlD","calendarButtons":"ClockData_calendarButtons__nZ9DK"};